import { Link } from 'react-router-dom';

interface CategoryCardProps {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

export default function CategoryCard({ slug, name, description, icon, count }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${slug}`}
      className="group bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6 hover:border-primary-300/60 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
    >
      <div className="w-11 h-11 rounded-lg bg-secondary-100 flex items-center justify-center mb-4 group-hover:bg-secondary-200 transition-colors duration-300">
        <i className={`${icon} text-xl text-secondary-600`} />
      </div>
      <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200">
        {name}
      </h3>
      <p className="mt-1.5 text-sm text-foreground-500 leading-relaxed line-clamp-2">
        {description}
      </p>
      <div className="mt-4 flex items-center justify-between">
        <span className="text-xs text-foreground-400">{count} 篇文章</span>
        <span className="text-xs font-medium text-primary-600 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          浏览 <i className="ri-arrow-right-line text-xs w-3 h-3 flex items-center justify-center" />
        </span>
      </div>
    </Link>
  );
}